module.exports = {
  name: '年度休假時數',
  schema: {
    type: 'Object',
    contents: {
      stafferRef: {
        type: 'ObjectId',
        name: '人員',
        reference: 'users',
        refKeys: ['name'],
      },
      type: {
        type: 'String',
        name: '假別',
        options: [
          '事假',
          '病假',
          '特休',
          '公出',
          '遲到',
          '曠職',
          '喪假',
          '育嬰假',
          '產假',
          '陪產假',
          '產檢假',
        ],
      },
      year: {
        type: 'Date',
        name: '年度',
        format: 'YYYY',
        parseFormat: 'YYYY',
        input: 'text',
      },
      qty: {
        type: 'Number',
        name: '可請假時數',
      },
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'stafferRef', width: 100 },
        { key: 'year', width: 100 },
        { key: 'type', width: 100 },
        { key: 'qty', width: 100 },
      ],
    },
    editor: {
      groups: [
        {
          name: '系統資料',
          rows: [
            [{ key: 'stafferRef' }],
            [{ key: 'year' }],
            [{ key: 'type' }],
            [{ key: 'qty' }],
          ],
        },
      ],
    },
  },
}



// WEBPACK FOOTER //
// ./src/models/leaveQtys.js